export default {
  data() {
    return { isExpirationSet: false };
  },
  methods: {
    async logoutUser() {
      try {
        await this.$store.dispatch("logoutUser");
      } catch (error) {
        console.log(error);
      }
    },
    isTokenActive() {
      try {
        var userData = this.$store.getters.userData;

        var exp = userData.exp;
        var expStamp = exp * 1000;
        // const expira = new Date(expStamp);
        //console.log(expira);
        const nowStamp = Date.now();
        //console.log(new Date(nowStamp));

        // pruebas
        //expStamp = nowStamp + 190 * 1000;

        if (expStamp > nowStamp) {
          var diffStamp = expStamp - 180 * 1000;
          var msToDiff = diffStamp - nowStamp;

          // if (this.isExpirationSet) return true;
          // this.isExpirationSet = true;
          this.timeoutId && clearTimeout(this.timeoutId);
          this.timeoutId = setTimeout(() => {
            this.$store.commit("SET_EXPIRED", true);
          }, msToDiff);
          return true;
        } else {
          this.isExpirationSet = false;
          return false;
        }
        /*
        const now = Date.now() / 1000; // exp is represented in seconds since epoch
        let newTime = exp - now;
        var fecha = new Date(newTime * 1000);
        console.log(fecha);
        var timeUntilRefresh = newTime - 120; //2 minutos antes de finalizar la sesión
        console.log(exp, newTime, timeUntilRefresh);
        return now < exp;
        */
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  }
};
